import useResource from './useResource';
import { convertToCamelCase } from '../helpers/utils';
import { BookingStatus, Pages } from '../constants/enums';
import { Token } from '../models/app';
import useAuth from './useAuth';
import useAdmin from './useAdmin';
import { useSelector } from 'react-redux';

const useListings = (slug: string) => {
  const resource = useResource();
  const { login, register, forgetPassword, forgetPasswordSubmit } = useAuth();
  const {
    adminsCreate,
    adminsDelete,
    adminsClearNextToken,
    adminsClearListing,
  } = useAdmin('admins', 'admin');
  // const bookingStatusFilter = useSelector(
  //   (state: any) => state.bookings.statusFilter,
  // );

  const api: any = {};
  const defaultOptions: any[] = [];
  const defaultHeadCells: any[] = [];
  const defaultDataCells: any[] = [];
  const defaultExportCells: any[] = [];
  const defaultFetchListing = (
    limit: number,
    nextToken: Token,
    setNextNextToken: any,
  ) => console.log(limit, nextToken, setNextNextToken);
  const defaultChangeListing = (listing: any[]) =>
    console.log('default changeListing ', listing);
  const defaultGetResource = (id: string) =>
    console.log('default getResource ', id);
  const defaultCreateResource = (data: any, state: any) =>
    console.log(data, state);
  const defaultUpdateResource = (id: string, data: any, state: any) =>
    console.log(id, data, state);
  const defaultTrashResource = (id: string) =>
    console.log('trash default function =>', id);
  const defaultBulkTrashResource = (ids: any) => console.log(ids);
  const defaultDeleteResource = (id: string) => console.log(id);
  const defaultExportResource = () => console.log('This is working...');
  const defaultClearListing = () => console.log('default clearListing');
  const defaultClearNextToken = () => console.log('default clearNextToken');

  for (let page of Object.values(Pages)) {
    if (slug === page) {
      if (slug === Pages.ADMINS || slug === Pages.STAFF_MEMBERS) {
        api.createResource = adminsCreate;
        slug === Pages.ADMINS ? (api.listing = []) : (api.waiterlisting = []);
        api.deleteResource = defaultDeleteResource;
        api.trashResource = adminsDelete;
        api.clearListing = adminsClearListing;
        api.clearNextToken = adminsClearNextToken;
      } else if (slug === Pages.LOGIN) {
        api.createResource = login;
      } else if (slug === Pages.REGISTER) {
        api.createResource = register;
      } else if (slug === Pages.FORGOT_PASSWORD) {
        api.createResource = forgetPassword;
      } else if (slug === Pages.RESET_PASSWORD) {
        api.createResource = forgetPasswordSubmit;
      } else {
        const resourceKey = convertToCamelCase(page);
        
        api.options =
          resource[`${resourceKey}Options`] !== undefined
            ? resource[`${resourceKey}Options`]
            : defaultOptions;
        api.headCells =
          resource[`${resourceKey}HeadCells`] !== undefined
            ? resource[`${resourceKey}HeadCells`]
            : defaultHeadCells;
        api.dataCells =
          resource[`${resourceKey}DataCells`] !== undefined
            ? resource[`${resourceKey}DataCells`]
            : defaultDataCells;
        api.exportCells =
          resource[`${resourceKey}ExportCells`] !== undefined
            ? resource[`${resourceKey}ExportCells`]
            : defaultExportCells;

        api.changeListings =
          resource[`${resourceKey}ChangeListing`] !== undefined
            ? resource[`${resourceKey}ChangeListing`]
            : defaultChangeListing;
        api.fetchListings =
          resource[`${resourceKey}Fetch`] !== undefined
            ? resource[`${resourceKey}Fetch`]
            : defaultFetchListing;
        api.getResource =
          resource[`${resourceKey}Get`] !== undefined
            ? resource[`${resourceKey}Get`]
            : defaultGetResource;
        api.createResource =
          resource[`${resourceKey}Create`] !== undefined
            ? resource[`${resourceKey}Create`]
            : defaultCreateResource;
        api.updateResource =
          resource[`${resourceKey}Update`] !== undefined
            ? resource[`${resourceKey}Update`]
            : defaultUpdateResource;
        api.trashResource =
          resource[`${resourceKey}Trash`] !== undefined
            ? resource[`${resourceKey}Trash`]
            : defaultTrashResource;
        api.bulkTrashResource =
          resource[`${resourceKey}BulkTrash`] !== undefined
            ? resource[`${resourceKey}BulkTrash`]
            : defaultBulkTrashResource;
        api.deleteResource =
          resource[`${resourceKey}Delete`] !== undefined
            ? resource[`${resourceKey}Delete`]
            : defaultDeleteResource;
        api.exportResource =
          resource[`${resourceKey}Export`] !== undefined
            ? resource[`${resourceKey}Export`]
            : defaultExportResource;
        api.resourceModel =
          resource[`${resourceKey}Model`] !== undefined
            ? resource[`${resourceKey}Model`]
            : null;

        api.createSubscription =
          resource[`${resourceKey}CreateSubscription`] !==
          undefined
            ? resource[`${resourceKey}CreateSubscription`]
            : '';
        api.nextToken =
          resource[`${resourceKey}NextToken`] !== undefined
            ? resource[`${resourceKey}NextToken`]
            : '';
        api.listing =
          resource[`${resourceKey}Listing`] !== undefined
            ? resource[`${resourceKey}Listing`]
            : [];
        api.clearListing =
          resource[`${resourceKey}ClearListing`] !== undefined &&
          typeof resource[`${resourceKey}ClearListing`] === 'function'
            ? resource[`${resourceKey}ClearListing`]
            : defaultClearListing;
        api.clearNextToken =
          resource[`${resourceKey}ClearNextToken`] !== undefined &&
          typeof resource[`${resourceKey}ClearNextToken`] === 'function'
            ? resource[`${resourceKey}ClearNextToken`]
            : defaultClearNextToken;
        api.prevNextToken =
          resource[`${resourceKey}PrevNextToken`] !== undefined
            ? resource[`${resourceKey}PrevNextToken`]
            : '';
      }
      // if (
      //   slug === Pages.BOOKINGS &&
      //   bookingStatusFilter === BookingStatus.TRANSFERED
      // ) {
      //   api.headCells =
      //     resource[`${convertToCamelCase(page)}TransferHeadCells`] !== undefined
      //       ? resource[`${convertToCamelCase(page)}TransferHeadCells`]
      //       : defaultHeadCells;
      // }
    }
  }
  return api;
};

export default useListings;
